<template>
  <BaseModal :modalTitle="title">
    <div class="mb-3 min-h-20">
      <p
        v-for="(line, index) in textLines"
        :key="index"
        :class="typeof line === 'object' && line.bold ? 'font-semibold' : ''">
        {{ typeof line === 'object' ? line.text : line }}
      </p>
    </div>

    <template #buttons>
      <UiBaseButton
        :text="$t('action.cancel')"
        theme="neutral"
        :isDisabled="isLoading"
        @button-click="onCancelClick" />
      <UiBaseButton
        :text="$t('action.continue')"
        theme="primary"
        :isLoading="isLoading"
        @button-click="onConfirmClick" />
    </template>
  </BaseModal>
</template>

<script lang="ts">
export default {
  name: 'ConfirmationModal',
  emits: ['cancel', 'close'],
  props: {
    title: {
      type: String,
      default: '',
    },
    textLines: {
      type: Array as () => (string | { text: string; bold?: boolean })[],
      required: true,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    async onConfirmClick() {
      this.isLoading = true
      try {
        await this.onConfirm()
        this.$emit('close')
      } finally {
        this.isLoading = false
      }
    },
    onCancelClick() {
      // A caller's `onCancel` arrives through the `cancel` event listener —
      // do not also call it directly, or it runs twice.
      this.$emit('cancel')
      this.$emit('close')
    },
  },
}
</script>

